import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import apiInstanceV2 from '../../Apis/AxiosV2';
import {
    ASSETS_SERVICE,
    AUTHENTICATION_SERVICE,
    EVENT_SERVICE,
    USER_SERVICE,
    VEHICLE_COMPANY_SERVICE,
    VISITOR_TYPES_SERVICE
} from '../EndPoints';
import axios from "axios";
import {URL} from "../../Apis/Constants";
import {errorMsg} from "../../Apis/functions";

export const GetEventFilters = createAsyncThunk('employeeEvents/getEventFilters', async () => {
    const response = await apiInstance
        .get(ASSETS_SERVICE.getEventFilters)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetAllVisitorTypes = createAsyncThunk('employeeEvents/getAllVisitorTypes', async () => {
    const response = await apiInstance
        .get(VISITOR_TYPES_SERVICE.getAllVisitorTypes)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetVisitorTypeByID = createAsyncThunk('employeeEvents/getVisitorTypeByID', async (id) => {
    const response = await apiInstance
        .get(`${VISITOR_TYPES_SERVICE.getVisitorTypeByID}${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const searchByEmail = createAsyncThunk('employeeEvents/searchByEmail', async (email) => {
    const response = await apiInstance
        .get(`${USER_SERVICE.searchByEmail}${email}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const searchByPhone = createAsyncThunk('employeeEvents/searchByPhone', async (phone) => {
    const response = await apiInstance
        .get(`${USER_SERVICE.searchByPhone}${phone}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const createNormalEvent = createAsyncThunk('employeeEvents/createNormalEvent', async (body) => {
    const response = await apiInstance
        .post(EVENT_SERVICE.createNormalEvent, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const getEventDetail = createAsyncThunk('employeeEvents/getEventDetail', async (eventId) => {
    const response = await apiInstance
        .get(`${EVENT_SERVICE.getEventDetail}${eventId}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const deleteUserInvitation = createAsyncThunk('employeeEvents/deleteUserInvitation', async (invitId) => {
    const response = await apiInstance
        .delete(`${EVENT_SERVICE.deleteUserInvitation}${invitId}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const cancelEvent = createAsyncThunk('employeeEvents/cancelEvent', async (id) => {
    const response = await apiInstance
        .put(`${EVENT_SERVICE.cancelEvent}${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const cancelEventByList = createAsyncThunk('employeeEvents/cancelEventByList', async (params) => {
    const response = await apiInstance
        .put(EVENT_SERVICE.cancelEventByList, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const companyRestrictions = createAsyncThunk('employeeEvents/companyRestrictions', async (companyId) => {
    const response = await apiInstanceV2
        .get(EVENT_SERVICE.companyRestrictions)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const getAllVehiclesData = createAsyncThunk('employeeEvents/getAllVehiclesData', async () => {
    const response = await apiInstance
        .get(VEHICLE_COMPANY_SERVICE.getAllVehiclesData)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const preRegisterUser = createAsyncThunk('employeeEvents/preRegisterUser', async (body) => {
    const response = await apiInstance
        .post('authentication-service/pre-register-user', body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const deleteEvents = createAsyncThunk('employeeEvents/deleteEvent', async (body) => {
    const response = await apiInstance
        .post(EVENT_SERVICE.deleteEvents, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const validateEvent = createAsyncThunk('employeeEvents/validateEvent', async ({ id, option }) => {
    const response = await apiInstance
        .put(EVENT_SERVICE.validateEvent(id, option))
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const deleteUserInvitationByIds = createAsyncThunk(
    'employeeEvents/deleteUserInvitationByIds',
    async ({ id, body }) => {
        const response = await apiInstance
            .post(`${EVENT_SERVICE.deleteUserInvitationByIds}${id}`, body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
///event-service/v1/reservation/get-free-schedules/by-zone
export const GetFreeShedules = createAsyncThunk('employeeEvents/getFreeShedules', async (body) => {
    const response = await apiInstance
        .post(EVENT_SERVICE.getFreeShedules, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetEventSetting = createAsyncThunk('employeeEvents/getEventSetting', async (body) => {
    const response = await apiInstance
        .get(EVENT_SERVICE.getEventSetting, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const UpdateEventSetting = createAsyncThunk('employeeEvents/UpdateEventSetting', async (body) => {
    const response = await apiInstance
        .put(EVENT_SERVICE.updateEventSetting, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateFileEventSetting = createAsyncThunk('employeeEvents/CreateFileEventSetting', async (body) => {
    const response = await apiInstance
        .post(`${EVENT_SERVICE.fileCreate}`, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const DeleteFileEventSetting = createAsyncThunk('employeeEvents/DeleteFileEventSetting', async (body) => {
    const response = await apiInstance
        .post(`${EVENT_SERVICE.fileDeleteByIds}`, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetUserInvitations = createAsyncThunk('employeeEvents/getUserInvitations', async (params) => {
    const response = await apiInstance
        .get(EVENT_SERVICE.getUserInvitations(params.id, params.userTypeId))
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GroupInvitationsByEventId = createAsyncThunk('employeeEvents/groupInvitationsByEventId', async (id) => {
    const response = await apiInstance
        .get(`${EVENT_SERVICE.groupInvitationsByEventId}${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetEventApprovalComments = createAsyncThunk('employeeEvents/getEventApprovalComments', async (id) => {
    const response = await apiInstance
        .get(`${EVENT_SERVICE.getEventApprovalComments}${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateUserInvitationEvent = createAsyncThunk('employeeEvents/createUserInvitationEvent', async (body) => {
    const response = await apiInstance
        .post(EVENT_SERVICE.createUserInvitationEvent, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetPublicEventDetail = createAsyncThunk('employeeEvents/getPublicEventDetail', async (eventId, { dispatch, getState }) => {
    try {
        return await axios.get(`${URL}${EVENT_SERVICE.getPublicEventDetail}${eventId}`, eventId);
    } catch (error) {
        if (!error.response) {
            errorMsg(error.response.status)
        }
        return { data: error.response.data, status: error.response.status };
    }
});


export const PublicCreateUserInvitations = createAsyncThunk('employeeEvents/publicCreateUserInvitations', async (params) => {
    try {
        return await axios.post(`${URL}${EVENT_SERVICE.publicCreateUserInvitations}`, params);
    } catch (error) {
        if (!error.response) {
            errorMsg(error.response.status)
        }
        return { data: error.response.data, status: error.response.status };
    }
});

export const PublicVerifyEmail = createAsyncThunk('employeeEvents/publicVerifyEmail', async (params) => {
    try {
        return await axios.post(`${URL}${EVENT_SERVICE.publicVerifyEmail}`, params);
    } catch (error) {
        if (!error.response) {
            errorMsg(error.response.status)
        }
        return { data: error.response.data, status: error.response.status };
    }
});

export const PublicProcessCompleted = createAsyncThunk('employeeEvents/publicProcessCompleted', async (userId) => {
    try {
        return await axios.get(`${URL}${AUTHENTICATION_SERVICE.publicProcessCompleted}${userId}`);
    } catch (error) {
        if (!error.response) {
            errorMsg(error.response.status)
        }
        return { data: error.response.data, status: error.response.status };
    }
});

export const CreateWhiteListReservationAutomatic = createAsyncThunk('employeeEvents/createWhiteListReservationAutomatic', async (body) => {
    const response = await apiInstance
        .post(EVENT_SERVICE.createWhiteListReservationAutomatic, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateWhiteListReservationManual = createAsyncThunk('employeeEvents/createWhiteListReservationManual', async (body) => {
    const response = await apiInstance
        .post(EVENT_SERVICE.createWhiteListReservationManual, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetUserReservationSummary = createAsyncThunk('employeeEvents/getUserReservationSummary', async (param) => {
    const response = await apiInstance
        .get(`${EVENT_SERVICE.getUserReservationSummary}${param}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CountEventWhiteList = createAsyncThunk('employeeEvents/countEventWhiteList', async (eventId) => {
    const response = await apiInstance
        .get(`${EVENT_SERVICE.countEventWhiteList}${eventId}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
